import Swal from 'sweetalert2';

export default async function (params, callback) {
    let result = await Swal.fire({
        title: 'Are you sure to print production sheet?',
        text: 'Note : Please disable popup blocker or allow popup window in your browser !',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'YES',
        cancelButtonText: 'NO'
    })
    if (result.value) {
        toastr.options = {
            "timeOut": false,
        }
        $Loading.show();
        try {
            let res1 = await fetchData(params);
            if (res1) {
                try {
                    let res2 = await axios({
                        url: 'shirt_orders/print/collector',
                        method: 'POST',
                        data: { params },
                        responseType: 'blob', // important
                    })
                    if (res2) {
                        let file = new Blob([res2.data], {
                            type: "text/html"
                        });
                        let url = URL.createObjectURL(file);
                        Object.assign(document.createElement('a'), { target: '_blank', href: url }).click();
                        callback(true);
                    }
                } catch (error) {
                    if (error.response.status === 403) {
                        toastr.error('Not authorized, please ensure that you have the required permissions.');
                    } else {
                        toastr.error('There was some errors, please correct and try again, or contact the admins');
                    }
                }
            }
            $Loading.hide();
        }
        catch (error) {
            $Loading.hide();
            throw error.response.data
        }
    }
    callback(false);
}


async function fetchData(params) {
    try {
        return await axios.post('shirt_orders/fetch_data', { params });
    } catch (error) {
        if (error.response.status === 403) {
            toastr.error('Not authorized, please ensure that you have the required permissions.');
        } else {
            toastr.error('There was some errors, please correct and try again, or contact the admins');
        }
    }
}
